import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'

export const StudentPaymentRep = createAsyncThunk('std-payment', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/rep/student-payments', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const orgPaymentRep = createAsyncThunk('org-payment', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/rep/org-payments', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type ReportState = {}

const initialState: ReportState = {}

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    reset: () => initialState,
  },
})

export const {reset} = reportSlice.actions
export default reportSlice.reducer
